import { Client } from "../../clients/client";

import { ShopTMSRegisterForm } from "./forms/ShopTMSRegisterForm";

export class TMSUseCase {
  constructor(private client: Client) {}

  public async registerShop(form: ShopTMSRegisterForm): Promise<any> {
    return this.client.tms.createShop(form);
  }
}
